import React from 'react';
import { Typography, Box, Container, Grid, Card, CardMedia, CardContent } from '@mui/material';
import { IMAGES, yellowGlowSx } from '../theme';
const services = [{
  title: 'Modern Flat-Roof & Cabana',
  description: 'Sleek, contemporary aluminum designs that deliver full coverage and a premium resort feel for your backyard.',
  image: IMAGES.hero
}, {
  title: 'Polycarbonate & Translucent',
  description: 'Enjoy natural light while blocking harmful UV rays and rain. Perfect for keeping a bright, protected patio area.',
  image: IMAGES.polycarbonate
}, {
  title: 'Solid Roof & Traditional',
  description: "Complete shade and weather protection with lattice and solid roof styles that match your home's architecture.",
  image: IMAGES.solid
}];
export function Services() {
  return <Box component="section" id="services" sx={{
    py: {
      xs: 8,
      md: 12
    },
    bgcolor: 'background.default'
  }} data-id="element-160">
      <Container maxWidth="lg" data-id="element-161">
        <Box sx={{
        textAlign: 'center',
        mb: 8,
        maxWidth: '800px',
        mx: 'auto'
      }} data-id="element-162">
          <Typography variant="h6" color="secondary.main" fontWeight="bold" textTransform="uppercase" letterSpacing={1} gutterBottom sx={yellowGlowSx} data-id="element-163">
            Our Products
          </Typography>
          <Typography variant="h2" color="primary.main" sx={{
          mb: 3,
          fontSize: {
            xs: '2.5rem',
            md: '3.5rem'
          }
        }} data-id="element-164">
            Custom Covers for Every Style
          </Typography>
          <Typography variant="h6" color="text.secondary" fontWeight="400" data-id="element-165">
            We design and build premium patio covers tailored to your specific
            needs, aesthetic preferences, and budget.
          </Typography>
        </Box>

        <Grid container spacing={4} data-id="element-166">
          {services.map(service => <Grid item xs={12} md={4} key={service.title} data-id="element-167">
              <Card sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            transition: 'transform 0.3s',
            '&:hover': {
              transform: 'translateY(-8px)'
            }
          }} data-id="element-168">
                <CardMedia component="img" height="260" image={service.image} alt={service.title} data-id="element-169" />
                <CardContent sx={{
              flexGrow: 1,
              p: 4
            }} data-id="element-170">
                  <Typography gutterBottom variant="h5" component="h3" color="primary.main" fontWeight="bold" data-id="element-171">
                    {service.title}
                  </Typography>
                  <Typography variant="body1" color="text.secondary" sx={{
                lineHeight: 1.6
              }} data-id="element-172">
                    {service.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>)}
        </Grid>
      </Container>
    </Box>;
}